module.exports = __webpack_public_path__ + "img/bank-15-sc.57822fe3.svg";